module.exports = __webpack_public_path__ + "img/enterpriseConnect.25d7599d.svg";